import FeatureCardGridView from "@/components/feature/FeatureCardGridView";
import { useFeatureTypeName } from "@/hooks/useFeatureTypeName";
import type { Feature, LayoutContext } from "@/lib/models";
import { FeatureService } from "@/services/FeatureService";
import { useEffect, useState } from "react";
import { useOutletContext, useParams } from "react-router";

const FeatureTypeFeatureListPage: React.FC = () => {
  const params = useParams();
  const { featureTypeName } = useFeatureTypeName(params.featureTypeId!);
  const { setPageName } = useOutletContext<LayoutContext>();
  const [featureList, setFeatureList] = useState<Feature[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setPageName(`Feature Type: ${featureTypeName} Features`);
  }, [featureTypeName, setPageName]);

  useEffect(() => {
    const fetchFeatures = async () => {
      if (!params.featureTypeId) {
        return;
      } 
      const features = await FeatureService.getByFeatureTypeId(params.featureTypeId!);
      setFeatureList(features);
      setIsLoading(false);
    };
    fetchFeatures();
  }, [params.featureTypeId]);

  return (
    <div className="container mx-auto p-4">
      <FeatureCardGridView pageTitle={`Feature Type: ${featureTypeName}`} featureList={featureList} isLoading={isLoading} />
    </div>
  );
};

export default FeatureTypeFeatureListPage;
